//domain
export const localhost = "localhost";
export const dev = "sdap.dev.samsungbdc.com";
export const stg = "sdap.stg.samsungbdc.com";
export const pre = "sdap.pre.samsungbdc.com";
export const prod = "privacy.samsung.com";
